<script setup>
/**
 * Layout de un modal de bootstrap
 */
import { clone, isString } from 'lodash';

import { computed } from 'vue';
import { isBlank } from '@/libs/strings';
import Spinner from './Spinner.vue';

const props = defineProps({
  id: { type: String, default: null },
  titulo: { type: String, default: null },
  mostrarBotonCerrar: { type: Boolean, default: null },
  classModal: { type: [String, Object], default: null },
  tamano: { type: String, default: 'md' },
  cargando: { type: Boolean, default: false },
  // Si marcamos un modal como de altura completa, el modal ocupa el 90% de la pantalla
  // y el cuerpo del modal es scrollable
  alturaCompleta: { type: Boolean, default: false },
});

const mostrarHeader = computed(() => !isBlank(props.titulo));

const classModalFinal = computed(() => {
  const claseTamano = `modal-${props.tamano}`;
  if (!props.classModal) {
    return claseTamano;
  }

  if (isString(props.classModal)) {
    return `${props.classModal} ${claseTamano}`;
  }

  const res = clone(props.classModal);
  res[claseTamano] = true;
  return res;
});

</script>

<template>
  <div
    :id="id"
    class="modal fade"
    :class="{ 'modal-full-height': alturaCompleta }"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog" :class="classModalFinal" role="document">
      <div class="modal-content">
        <!-- Si no hay título pero quieren el botón, lo pintamos aquí -->
        <button
          v-if="!titulo && mostrarBotonCerrar === true"
          type="button"
          class="close m-3 position-relative"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <slot name="modalHeader">
          <div v-if="mostrarHeader" class="modal-header">
            <button
              v-if="mostrarBotonCerrar !== false"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h5 class="border-bottom modal-title" v-html="titulo" />
          </div>
        </slot>
        <Spinner v-if="cargando" class="m-t"></Spinner>
        <slot name="modalBody">
          <div
            ref="contenido-wrapper"
            class="modal-body"
            :class="{ 'm-t-n': mostrarHeader}"
          >
            <slot></slot>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .close {
    z-index: 9999;
  }
</style>
